export class CreateApplicationRoutingConstants {
    static CREATE_APPLICATION_ROUTE = "create-application";
    static LOCATION_ROUTE = "location";
    static DETAILS_ROUTE = "details";
    static APPLICANT_ROUTE = "applicant";
    static AGENT_ROUTE = "agent";
    static WELCOME_ROUTE = "welcome";
    static PROFESSIONAL_BODIES_ROUTE = "professionalbodies";
    static BURIAL_ROUTE = "burialdetails";
    static DECEASED_ROUTE = "deceaseddetails";
    static FAMILY_ROUTE = "familymemberdetails";
    static REQUIRED_DOCS = "documentation";
    static REFRESH_ROUTE = "refresh-create-application";
    static FUNERAL_PARLOUR = "funeralparlour";
    static STAKEHOLDERS_ROUTE = "stakeholders";
    static REFRESH_VIEW_APPLICATION_ROUTE = "refreshViewApplication";
}
